import type { ServerDto } from '@lagerfeuer/shared';
import { useState } from 'react';
import { initials } from '../../components/Avatar';
import { useAppStore } from '../../store/app';

/**
 * Server-Icon (animiert erlaubt) oder Initialen auf Glut-Verlauf. Animierte Icons spielen bei ausgeschaltetem
 * „GIFs automatisch abspielen" nur bei Hover/Fokus (eine statische Variante sieht der Vertrag nicht vor).
 */
export function ServerIcon({ server, size = 48 }: { server: Pick<ServerDto, 'name' | 'iconUrl'> & { iconAnimated?: boolean }; size?: number }) {
  const [broken, setBroken] = useState(false);
  const [hover, setHover] = useState(false);
  const autoplay = useAppStore((s) => s.settings?.autoplayGifs ?? true);
  const paused = !!server.iconAnimated && !autoplay && !hover;
  const hoverProps = server.iconAnimated ? { onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false) } : {};
  if (server.iconUrl && !broken && !paused) {
    return (
      <img
        className={`server-icon ${server.iconAnimated ? 'server-icon-animated' : ''}`}
        src={server.iconUrl}
        alt=""
        width={size}
        height={size}
        onError={() => setBroken(true)}
        draggable={false}
        data-testid="server-icon-img"
        {...hoverProps}
      />
    );
  }
  return (
    <span
      className="server-icon server-icon-fallback"
      style={{ width: size, height: size, fontSize: Math.max(11, size * 0.32) }}
      aria-hidden="true"
      data-testid="server-icon-fallback"
      data-paused={paused || undefined}
      {...hoverProps}
    >
      {initials(server.name).slice(0, 3)}
    </span>
  );
}
